<template>
  <div class="code-cell">
    <div class="code-cell-left">
      <div class="title">{{ item.questitle }}</div>
      <div class="middle">
        <span
          >通过率： <span class="blue">{{ lv }}%</span>
        </span>
        <span
          >分数： <span class="blue">{{ item.fenzhi }}</span>
        </span>
        <span
          >难度：
          <span class="blue" v-if="item.nandu < 3">低</span>
          <span class="blue" v-else-if="item.nandu == 3">中</span>
          <span class="blue" v-else>高</span>
        </span>
      </div>
      <div class="bottom font-desc">
        <span>阅读：{{ item.readCount || 0 }} |</span
        ><span>作答：{{ item.cUseCount || 0 }} |</span
        ><span class="cursor" @click="zanHandler"
          ><i class="iconfont icongood" style="font-size: 12px"></i> 赞：{{
            dianz
          }}</span
        >
      </div>
    </div>
    <div class="code-cell-right">
      <a class="btn-small" @click="enterHandler">开始解答</a>
    </div>
  </div>
</template>
<script>
import { LOGIN_API } from "@/api.js";
export default {
  name: 'code-cell',
  props: ['item', 'paperId'],
  data() {
    return {
      dianz: 0,
    }
  },
  computed: {
    lv() {
      if (this.item.totalRunCount == 0) {
        return 0
      }
      return (this.item.passSuccCount * 100) / this.item.totalRunCount
    },
    loginStatus() {
      return this.$store.state.app.login //需要监听的数据
    },
  },
  watch: {
    item(val) {
      this.dianz = val.collectCount || 0
    },
  },
  mounted() {
    this.dianz = this.item.collectCount || 0
  },
  methods: {
    enterHandler() {
      //检查登录状态
      /*if (!this.loginStatus) {
        this.$bus.emit('checkUserLogin')
        return
      }*/
      this.addLog(1, this.item._id, this.paperId, () => {
       
          location.href = '/ojques.html?id=' + this.item._id;
      })
    },
    addLog(type, questionId, paperId, callBack) {
      //type 1阅读，type 2 答题次数 type3 赞)
      const post = {
        type: type,
        questionId: questionId,
        paperId: paperId,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/addLog`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (callBack) {
              callBack()
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    zanHandler() {
      if (!this.loginStatus) {
        this.$bus.emit('checkUserLogin')
        return
      }
      this.addLog(3, this.item._id, this.paperId, () => {
        this.$message.success('点赞成功！')
        this.dianz += 1
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.code-cell {
  display: inline-block;
  width: 490px;
  border: 1px solid #eff0f2;
  padding: 20px;
  margin: 10px;
  background: #fff;
  .code-cell-left {
    .title {
      font-size: 16px;
      font-weight: bold;
    }
    .middle {
      font-size: 14px;
      font-weight: 340;
      padding: 10px 0;
      span {
        padding: 0 10px 0 0;
      }
      .blue {
        color: #29bdb9;
      }
    }
    .bottom {
      span {
        padding: 0 4px 0 0;
      }
    }
  }
  .cursor {
    cursor: pointer;
  }
  .code-cell-right {
    float: right;
    margin-top: -60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/practice/code/code-cell.vue